<template lang="pug">
    section#indicado
        div.wrapper
            h2 PARA QUEM É INDICADO O CURSO?
            p
                |O conteúdo de curso de 
                strong Pós-Graduação Educação a Distância 4.0 
                |é destinado aos profissionais da educação, professores, auxiliares pedagógicos, diretores de escolas, 
                |e outras áreas afins, que procuram se inserir num novo cenário da educação aproveitando a oportunidade de crescimento 
                |que a metodologia pode proporcionar, bem como em outros espaços de educação informal em que a educação a distância 
                |pode contribuir, considerando a questão do tempo, da segurança e do valor de investimento – itens muito importantes no atual cenário.
                br
                strong Você tem até o dia 15/06/2020 para se matricular!
</template>

<script>
export default {
    name: "section-indicado"
}
</script>

<style lang="stylus" scoped src="./Indicado.styl"></style>